var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreadsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1995_139468)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1995_139468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 0.00195312H0V32.002H32V0.00195312Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1995_139468)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1995_139468)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23808 0.00195312H24.7619C28.7619 0.00195312 32 3.24005 32 7.24003V24.7639C32 28.7639 28.7619 32.002 24.7619 32.002H7.23808C3.2381 32.002 0 28.7639 0 24.7639V7.24003C0 3.24005 3.2381 0.00195312 7.23808 0.00195312Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.23828 0.202148H24.7621C28.6516 0.202148 31.8002 3.3507 31.8002 7.24023V24.7641C31.8002 28.6536 28.6516 31.8021 24.7621 31.8021H7.23828C3.34875 31.8021 0.200195 28.6536 0.200195 24.7641V7.24023C0.200195 3.3507 3.34875 0.202148 7.23828 0.202148Z",
    stroke: "black",
    strokeOpacity: 0.05
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1995_139468",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 26,
    height: 26
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1563 3.9707H3.96875V28.1582H28.1563V3.9707Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1995_139468)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7991 15.1812C21.6949 15.1312 21.5891 15.0831 21.4819 15.0371C21.2952 11.5971 19.4155 9.62767 16.2593 9.60751C16.245 9.60743 16.2308 9.60743 16.2164 9.60743C14.3286 9.60743 12.7585 10.4133 11.7922 11.8796L13.528 13.0704C14.2499 11.975 15.3829 11.7416 16.2173 11.7416C16.2269 11.7416 16.2366 11.7415 16.2461 11.7416C17.2854 11.7483 18.0696 12.0504 18.5771 12.6397C18.9465 13.0686 19.1935 13.6614 19.3158 14.4096C18.3944 14.253 17.398 14.2048 16.3327 14.2659C13.3319 14.4388 11.4028 16.1889 11.5323 18.6208C11.5981 19.8543 12.2126 20.9156 13.2627 21.6088C14.1505 22.1948 15.2939 22.4814 16.4823 22.4165C18.0517 22.3305 19.2828 21.7318 20.1418 20.6369C20.794 19.8055 21.2066 18.728 21.3888 17.3703C22.1367 17.8217 22.691 18.4157 22.9971 19.1297C23.5177 20.3435 23.548 22.3381 21.9206 23.9642C20.4946 25.3887 18.7806 26.005 16.1902 26.024C13.3168 26.0028 11.1436 25.0812 9.73069 23.285C8.40761 21.6031 7.72385 19.1738 7.69833 16.0644C7.72385 12.9551 8.40761 10.5257 9.73069 8.84383C11.1436 7.04767 13.3167 6.12615 16.1902 6.10479C19.0844 6.12631 21.2954 7.05227 22.7624 8.85707C23.4818 9.74215 24.0241 10.8552 24.3816 12.1529L26.4158 11.6102C25.9824 10.0128 25.3005 8.63635 24.3726 7.49475C22.4918 5.18091 19.7413 3.99529 16.1972 3.9707H16.183C12.6462 3.9952 9.92645 5.18535 8.09933 7.50803C6.47341 9.57495 5.63473 12.4509 5.60653 16.056L5.60645 16.0644L5.60653 16.073C5.63473 19.678 6.47341 22.554 8.09933 24.6209C9.92645 26.9436 12.6462 28.1338 16.183 28.1582H16.1972C19.3417 28.1364 21.5581 27.3132 23.384 25.4889C25.7729 23.1023 25.701 20.1107 24.9136 18.2742C24.3487 16.9572 23.2718 15.8876 21.7991 15.1812ZM16.37 20.2856C15.0548 20.3596 13.6884 19.7693 13.621 18.5049C13.5711 17.5674 14.2882 16.5212 16.4507 16.3966C16.6983 16.3823 16.9413 16.3753 17.18 16.3753C17.9655 16.3753 18.7003 16.4517 19.3684 16.5977C19.1192 19.7096 17.6576 20.2149 16.37 20.2856Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1995_139468",
    x: -0.299805,
    y: -1.29785,
    width: 32.6001,
    height: 33.5996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1995_139468"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1995_139468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.00195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreadsIcon);
export default __webpack_public_path__ + "static/media/threads-icon.26fcb67148f6f747f317357e6c480c2f.svg";
export { ForwardRef as ReactComponent };